"use client";

import { ChevronRight } from "lucide-react";

import { EXAMPLE_WORKFLOWS, HOME_GREETING } from "@/features/home/data/mock";
import { cn } from "@/shared/lib/utils/cn";

interface ExampleWorkflowsLinkProps {
  open: boolean;
  onToggle: () => void;
  onSelect: (example: string) => void;
}

export function ExampleWorkflowsLink({ open, onToggle, onSelect }: ExampleWorkflowsLinkProps) {
  return (
    <div>
      <button
        type="button"
        onClick={onToggle}
        className="flex items-center gap-1.5 text-[12px] font-medium text-muted-foreground/50 transition-colors hover:text-[var(--spark-orange)]"
      >
        <span>{open ? HOME_GREETING.examplesHideLabel : HOME_GREETING.examplesLabel}</span>
        <ChevronRight
          className={cn("size-3.5 stroke-[1.75] transition-transform", open && "rotate-90")}
        />
      </button>

      {open ? (
        <div className="mt-3 space-y-2">
          {EXAMPLE_WORKFLOWS.map((example, index) => (
            <button
              key={example}
              type="button"
              onClick={() => onSelect(example)}
              className={cn(
                "w-full rounded-xl border border-border/40 bg-card/60 px-4 py-3 text-left text-[12px] leading-relaxed font-medium",
                "text-muted-foreground/70 transition-all",
                "hover:border-[color-mix(in_srgb,var(--spark-orange)_30%,var(--border))] hover:bg-card hover:text-foreground hover:shadow-sm",
                index % 2 === 0
                  ? "hover:shadow-[0_0_0_1px_color-mix(in_srgb,var(--breeze-blue)_12%,transparent)]"
                  : "hover:shadow-[0_0_0_1px_color-mix(in_srgb,var(--logo-ai-from)_18%,transparent)]",
              )}
            >
              {example}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
